import { FC } from 'react';

import { useCheckPermission } from '../../../shared/Helpers/hooks';
import { AdminTypes } from '../../../components/Menu';
import { PERMISSIONS } from '../../../App/constants';
import Details from './details';
import DownloadSOAPNote from './download';
import Edit from './edit';
import View from './view';
import Unlock from './unlock';

import { useSelector } from '../../../redux/store';
import { SoapNotesFullProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';
import { SoapNotesStatuses } from '../../../redux/API/ClientAPIHelpers/dataCollectionProperties';

const Actions: FC<{ data: SoapNotesFullProperties }> = ({ data }) => {
	const DOWNLOAD = useCheckPermission(PERMISSIONS.SOAPNOTE.PDF);
	const UNLOCK = useCheckPermission(PERMISSIONS.SOAPNOTE.UNLOCK);
	const EDIT = useCheckPermission(PERMISSIONS.SOAPNOTE.EDIT);
	const POST_SUBMIT_EDIT = useCheckPermission(PERMISSIONS.SOAPNOTE.POST_SUBMIT_EDIT);

	const role = useSelector((state) => state.account.role);
	const userId = useSelector((state) => state.account.user.id);

	const { id, status } = data;

	const isAdmin = role?.section.id === AdminTypes.admin;
	const isExpired = status.status === SoapNotesStatuses.expiredWeek || status.status === SoapNotesStatuses.expired48;

	const isEditable = status.status === SoapNotesStatuses.draft || status.status === SoapNotesStatuses.unlocked;

	const isSubmitted = status.status === SoapNotesStatuses.submitted;
	const isPendingBt = status.status === SoapNotesStatuses.pendingBT;

	const canUserEdit = data.user.id === userId || isAdmin;
	const canAdminEditSubmitted = isAdmin && POST_SUBMIT_EDIT.permissionGranted;

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				gap: 16,
				cursor: 'pointer',
				justifyContent: 'flex-end',
			}}
		>
			{isExpired && (isAdmin || role?.section.id === AdminTypes.bcba) && (
				<>
					{UNLOCK.permissionGranted && <Unlock reportId={id} clientId={data.client.id} />}
					<Edit data={data} isViewOnly={isExpired} />
				</>
			)}
			{isEditable && EDIT.permissionGranted && <Edit data={data} isViewOnly={!canUserEdit} />}
			{isSubmitted && (
				<>
					{canAdminEditSubmitted && <Edit data={data} isViewOnly={false} isPostSubmit />}
					<View reportId={data.id} />
					{DOWNLOAD.permissionGranted && role?.section.id !== AdminTypes.bt && <DownloadSOAPNote data={data} />}
				</>
			)}
			{isPendingBt && <View reportId={data.id} />}
			<Details data={data} />
		</div>
	);
};

export default Actions;
